import { createRoot } from "react-dom/client";
import "./index.css";
import "./styles/premium.css";
// Initialize the theme store: rehydrates the persisted preference and starts the
// OS-change listener. The pre-paint script in index.html has already set the
// correct data-theme (no FOUC); this keeps the React store in sync.
import "./store/themeStore";
import App from "./App.tsx";

// Build marker. Bumping it also rotates the main bundle hash when a deploy
// must ship new /assets/* URLs (e.g. after a poisoned-edge-cache incident).
(window as Window & { __wlBuild?: string }).__wlBuild = "2026-08-05.2";

// Render app immediately for fastest LCP
// Note: StrictMode removed to prevent AbortError in Supabase auth initialization
// StrictMode causes double-mount which aborts in-flight auth requests
createRoot(document.getElementById("root")!).render(<App />);

// Defer non-critical initialization until after paint
// This improves LCP by ~500-1000ms on mobile

// Initialize Sentry after first paint (error monitoring can wait)
requestAnimationFrame(() => {
  setTimeout(() => {
    import("./lib/sentry").then(({ initSentry }) => {
      initSentry();
    });
  }, 100);
});

// Defer cache initialization until browser is idle
// IndexedDB operations can block the main thread
if (typeof window !== "undefined" && "requestIdleCallback" in window) {
  requestIdleCallback(
    () => {
      import("./analysis/nlp/cache").then(({ initializeCaches }) => {
        initializeCaches().catch(() => {
          // Silently ignore cache initialization failures
        });
      });
    },
    { timeout: 5000 },
  );
} else {
  // Fallback for Safari - use setTimeout after paint
  setTimeout(() => {
    import("./analysis/nlp/cache").then(({ initializeCaches }) => {
      initializeCaches().catch(() => {
        // Silently ignore cache initialization failures
      });
    });
  }, 3000);
}

// The service worker was RETIRED. Its fixed-version, cache-first cache could serve
// a stale app shell after a deploy — the stale shell referenced deleted/renamed
// chunks, so a dynamic import() would fail and blank the whole page. We no longer
// register it, and we proactively unregister any previously-registered SW and drop
// its caches so a returning visitor whose app still boots is healed immediately.
// (Visitors the stale SW fully blanks are healed by the self-unregistering
// public/sw.js on the browser's next SW update check.)
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then((regs) => regs.forEach((r) => r.unregister()))
    .catch(() => {});
  if (typeof caches !== "undefined") {
    caches
      .keys()
      .then((keys) => keys.forEach((k) => caches.delete(k)))
      .catch(() => {});
  }
}
